import {BASE_URL} from '../../api'
import API_LINKS from '../../constant/api.links'
import config from '../config'
const {axios} = config

type Contact = {
  email?: string
  phoneNumber?: string
}
type Settings = {
  termsAndConditions?: string
  privacyPolicy?: string
  contact?: Contact
  // Admin-editable mobile app login/sign-up branding - see
  // Setting.model.js on the backend. Added 2026-09-22.
  logoUrl?: string
  logoUrlEs?: string
  signInWelcomeText?: string
  signInWelcomeTextEs?: string
  signUpWelcomeText?: string
  signUpWelcomeTextEs?: string
}
const useSetting = () => {
  const getSettings = async () => {
    try {
      const url = BASE_URL + API_LINKS.GET_SETTINGS
      const {data, status} = await axios.get(url)

      return {data, status}
    } catch (error: any) {
      throw new Error(error)
    }
  }

  const updateSettings = async (settings: Settings, set: string) => {
    try {
      const url = BASE_URL + API_LINKS.UPDATE_SETTINGS
      const requestData = {
        ...settings,
        set: set,
      }
      const {data, status} = await axios.put(url, requestData)
      return {data, status}
    } catch (error: any) {
      throw new Error(error)
    }
  }

  return {getSettings, updateSettings}
}

export default useSetting
